export default __webpack_public_path__ + "static/media/four.7d964f28.jpg";